import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rainbow-six',
  templateUrl: './rainbow-six.component.html',
  styleUrls: ['./rainbow-six.component.css']
})
export class RainbowSixComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
